import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetAutomationById, IResponseGetAutomationById } from "./types"
import { GetAutomationByIdUrl } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getAutomationById(
	{ ...rest }: IPropsGetAutomationById,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetAutomationById> =
			await apiPrivate.get(`${GetAutomationByIdUrl}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetAutomationById(
	data: IPropsGetAutomationById,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetAutomationById,
					unknown,
					IResponseGetAutomationById
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETCALENDERDATA, ...Object.values(data)],
		queryFn: () => getAutomationById(data, apiPrivate),
		...options,
	})
}
